module.exports = __webpack_public_path__ + "octopus-service-440.d67f868bec6e1167abe0f9f649f4f34f.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/Avatar/img/octopus-service-440.svg
// module id = 1645
// module chunks = 8